/* AagamStuti theme script. Plain JavaScript, no libraries. */
(function () {
  'use strict';

  var AS = window.AS || {};
  var routes = AS.routes || {};
  var doc = document;
  var root = doc.documentElement;
  var body = doc.body;

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function store(key, val) {
    try { if (val === undefined) return localStorage.getItem(key); localStorage.setItem(key, val); } catch (e) {}
    return null;
  }

  /* ---------- Locks, focus trap ---------- */
  var lastFocus = null;
  var openCount = 0;
  function lockScroll(lock) {
    openCount += lock ? 1 : -1;
    if (openCount < 0) openCount = 0;
    body.style.overflow = openCount > 0 ? 'hidden' : '';
  }
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function trap(container, e) {
    if (e.key !== 'Tab') return;
    var items = $$(FOCUSABLE, container).filter(function (n) { return n.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function openLayer(el, focusEl) {
    if (!el || !el.hidden) return;
    lastFocus = doc.activeElement;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    lockScroll(true);
    var target = focusEl || $(FOCUSABLE, el);
    if (target) setTimeout(function () { target.focus(); }, 30);
  }
  function closeLayer(el) {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    el.hidden = true;
    lockScroll(false);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  var layers = function () { return $$('#index-menu,#search-overlay,#cart-drawer,#filter-drawer').filter(function (n) { return !n.hidden; }); };
  on(doc, 'keydown', function (e) {
    var open = layers();
    if (!open.length) return;
    var top = open[open.length - 1];
    if (e.key === 'Escape') { closeLayer(top); var mb = $('[data-menu-open]'); if (mb) mb.setAttribute('aria-expanded', 'false'); return; }
    trap(top, e);
  });

  /* ---------- Dusk switch ---------- */
  function currentTheme() {
    var t = root.getAttribute('data-theme');
    if (t) return t;
    return window.matchMedia && matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  function syncDusk() {
    var dark = currentTheme() === 'dark';
    $$('[data-dusk-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', dark ? 'true' : 'false');
      b.setAttribute('aria-label', dark ? 'Switch to day mode' : 'Switch to dusk mode');
    });
  }
  on(doc, 'click', function (e) {
    var b = e.target.closest('[data-dusk-toggle]');
    if (!b) return;
    var next = currentTheme() === 'dark' ? 'light' : 'dark';
    root.setAttribute('data-theme', next);
    store('as-theme', next);
    syncDusk();
  });
  syncDusk();

  /* ---------- Index menu ---------- */
  var menu = $('#index-menu');
  function setMenuRow(i) {
    if (!menu) return;
    var rows = $$('.as-idx__row', menu), pv = $$('.as-idx__arch', menu), cap = $('[data-capout]', menu);
    rows.forEach(function (r, j) { r.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    pv.forEach(function (p, j) { p.dataset.on = j === i ? 'true' : 'false'; });
    if (cap && rows[i]) cap.textContent = rows[i].dataset.cap || '';
  }
  if (menu) {
    $$('.as-idx__row', menu).forEach(function (r, i) {
      on(r, 'mouseenter', function () { setMenuRow(i); });
      on(r, 'focus', function () { setMenuRow(i); });
    });
    setMenuRow(0);
  }
  on(doc, 'click', function (e) {
    var o = e.target.closest('[data-menu-open]');
    if (o && menu) { openLayer(menu, $('.as-idx__row', menu)); o.setAttribute('aria-expanded', 'true'); return; }
    if (e.target.closest('[data-menu-close]')) { closeLayer(menu); $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); }
    if (menu && !menu.hidden && e.target.closest('#index-menu a[href]')) { closeLayer(menu); }
  });

  /* ---------- Search sheet ---------- */
  var search = $('#search-overlay');
  var sInput = $('[data-search-input]');
  var sResults = $('[data-search-results]');
  var sForm = $('[data-search-form]');
  var occasion = '';
  function pillLabel(sel, text, fallback) { $$(sel).forEach(function (n) { n.textContent = text || fallback; }); }
  function runSuggest() {
    if (!sInput || !sResults || !routes.suggest) return;
    var q = sInput.value.trim();
    pillLabel('[data-seg-q]', q, 'Idol, diya, mala');
    if (q.length < 2) { sResults.innerHTML = ''; return; }
    var url = routes.suggest + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4&section_id=predictive-search';
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = doc.createElement('div'); tmp.innerHTML = html;
      var sec = $('.shopify-section', tmp) || tmp;
      if (sInput.value.trim() === q) sResults.innerHTML = sec.innerHTML;
    }).catch(function () {});
  }
  var runSuggestSoon = debounce(runSuggest, 250);
  on(sInput, 'input', runSuggestSoon);
  on(doc, 'click', function (e) {
    var o = e.target.closest('[data-search-open]');
    if (o && search) {
      e.preventDefault();
      var which = o.getAttribute('data-search-open');
      openLayer(search, sInput);
      var g = $('[data-group="' + which + '"]', search);
      if (g && which !== 'q') { g.classList.add('is-hint'); setTimeout(function () { g.classList.remove('is-hint'); }, 1200); }
      return;
    }
    if (e.target.closest('[data-search-close]')) { closeLayer(search); return; }
    var term = e.target.closest('[data-term]');
    if (term && sInput) { sInput.value = term.getAttribute('data-term'); runSuggest(); sInput.focus(); return; }
    var occ = e.target.closest('[data-occasion]');
    if (occ) {
      var same = occ.getAttribute('aria-pressed') === 'true';
      $$('[data-occasion]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      occasion = same ? '' : occ.getAttribute('data-occasion');
      if (!same) occ.setAttribute('aria-pressed', 'true');
      pillLabel('[data-seg-occasion]', occasion, 'Any occasion');
      return;
    }
    var bud = e.target.closest('[data-budget]');
    if (bud) {
      var was = bud.getAttribute('aria-pressed') === 'true';
      $$('[data-budget]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      var mn = $('[data-price-min]'), mx = $('[data-price-max]');
      if (was) { mn.disabled = true; mx.disabled = true; pillLabel('[data-seg-budget]', '', 'Any price'); return; }
      bud.setAttribute('aria-pressed', 'true');
      mn.value = bud.getAttribute('data-min') || ''; mx.value = bud.getAttribute('data-max') || '';
      mn.disabled = !mn.value; mx.disabled = !mx.value;
      pillLabel('[data-seg-budget]', bud.getAttribute('data-budget'), 'Any price');
    }
  });
  on(sForm, 'submit', function () {
    if (!sInput) return;
    var q = sInput.value.trim();
    if (occasion && q.toLowerCase().indexOf(occasion.toLowerCase()) === -1) q = (q + ' ' + occasion).trim();
    if (!q) q = '*';
    sInput.value = q;
  });

  /* ---------- Cart ---------- */
  function setCount(n) {
    $$('[data-cart-count],[data-cart-count-inline]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
    $$('.as-hdr__bag').forEach(function (a) { a.setAttribute('aria-label', 'Bag, ' + n + ' items'); });
  }
  function parseSection(html, sel) {
    var tmp = doc.createElement('div'); tmp.innerHTML = html;
    return $(sel, tmp);
  }
  function refreshCart() {
    var jobs = [];
    jobs.push(fetch(routes.cartJs, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); return c; }));
    var drawer = $('#cart-drawer');
    if (drawer) {
      jobs.push(fetch(routes.root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (d) {
        var fresh = parseSection(d['cart-drawer'] || '', '#cart-drawer');
        if (!fresh) return;
        var b = $('[data-cart-drawer-body]', drawer), nb = $('[data-cart-drawer-body]', fresh);
        if (b && nb) b.innerHTML = nb.innerHTML;
        var f = $('[data-cart-drawer-foot]', drawer), nf = $('[data-cart-drawer-foot]', fresh);
        if (f && nf) f.innerHTML = nf.innerHTML;
        else if (f && !nf) f.remove();
        else if (!f && nf) $('.as-drawer2', drawer).appendChild(nf);
      }));
    }
    var page = $('[data-cart-section]');
    if (page) {
      jobs.push(fetch(routes.cart + '?section_id=' + page.getAttribute('data-section-id')).then(function (r) { return r.text(); }).then(function (html) {
        var fresh = parseSection(html, '[data-cart-section]');
        if (fresh) page.innerHTML = fresh.innerHTML;
      }));
    }
    return Promise.all(jobs);
  }
  function openDrawer() { var d = $('#cart-drawer'); if (d) { openLayer(d, $('[data-cart-close]', d)); } }
  function afterAdd() {
    return refreshCart().then(function () {
      if (AS.cartType === 'page') { location.href = routes.cart; }
      else openDrawer();
    });
  }
  function addItems(items) {
    return fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); });
  }
  on(doc, 'click', function (e) {
    var o = e.target.closest('[data-cart-open]');
    if (o && AS.cartType !== 'page' && $('#cart-drawer') && !/\/cart(\?|$)/.test(location.pathname + location.search) ) {
      e.preventDefault(); refreshCart().then(openDrawer, openDrawer); return;
    }
    if (e.target.closest('[data-cart-close]')) { closeLayer($('#cart-drawer')); return; }

    var q = e.target.closest('[data-quick-add]');
    if (q) {
      e.preventDefault();
      var label = $('span', q), old = label ? label.textContent : '';
      q.disabled = true;
      addItems([{ id: Number(q.getAttribute('data-quick-add')), quantity: 1 }]).then(function (res) {
        q.disabled = false;
        if (!res.ok) { if (label) label.textContent = 'Unavailable'; setTimeout(function () { if (label) label.textContent = old; }, 1800); return; }
        if (label) label.textContent = 'Added';
        setTimeout(function () { if (label) label.textContent = old; }, 1800);
        afterAdd();
      });
      return;
    }
    var set = e.target.closest('[data-add-set]');
    if (set) {
      e.preventDefault();
      var ids = set.getAttribute('data-add-set').split(',').filter(Boolean).map(function (id) { return { id: Number(id), quantity: 1 }; });
      set.disabled = true;
      addItems(ids).then(function () { set.disabled = false; afterAdd(); });
      return;
    }
    var lq = e.target.closest('[data-line-qty]');
    if (lq) {
      e.preventDefault();
      var line = lq.closest('[data-line]');
      var key = line.getAttribute('data-line');
      var qty = Number(lq.getAttribute('data-line-qty'));
      line.classList.add('is-busy');
      fetch(routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function () { return refreshCart(); }).catch(function () { line.classList.remove('is-busy'); });
    }
  });

  /* ---------- Product page ---------- */
  function initProduct(sec) {
    var data = [];
    try { data = JSON.parse($('[data-variants]', sec).textContent); } catch (e) { return; }
    var form = $('[data-product-form]', sec);
    var idInput = $('[data-variant-id]', sec);
    var priceEl = $('[data-price]', sec), cmpEl = $('[data-compare]', sec);
    var addBtn = $('[data-add-to-cart]', sec), addLabel = $('[data-add-label]', sec);
    var stock = $('[data-stock]', sec);
    var stickyPrice = $('[data-sticky-price]', sec);
    var errorEl = $('[data-form-error]', sec);
    var qtyIn = $('[data-qty]', sec), qtyOut = $('[data-qty-out]', sec);
    var opts = $$('[data-option]', sec);

    function selected() { return opts.map(function (g) { var b = $('[aria-pressed="true"]', g); return b ? b.getAttribute('data-value') : null; }); }
    function find(sel) {
      return data.filter(function (v) {
        return sel.every(function (val, i) { return val === null || v['o' + (i + 1)] === val; });
      })[0];
    }
    function showSlide(id) {
      var g = $('[data-gallery]', sec);
      if (!g || !id) return;
      var target = $('[data-media-id="' + id + '"]', g);
      if (!target) return;
      $$('.as-gal__slide', g).forEach(function (s) { s.hidden = s !== target; });
      $$('[data-media-target]', g).forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-media-target') === String(id) ? 'true' : 'false'); });
      var all = $$('.as-gal__slide', g), i = all.indexOf(target) + 1, c = $('[data-gallery-count]', g);
      if (c) c.textContent = i + ' / ' + all.length;
    }
    function update() {
      var sel = selected();
      var v = find(sel);
      opts.forEach(function (g, gi) {
        var chosen = $('[aria-pressed="true"]', g);
        var out = $('[data-option-selected]', g);
        if (out && chosen) out.textContent = chosen.getAttribute('data-value');
        $$('button[data-value]', g).forEach(function (b) {
          var probe = sel.slice(); probe[gi] = b.getAttribute('data-value');
          var m = find(probe);
          b.classList.toggle('is-soldout', !!m && !m.available);
          b.classList.toggle('is-missing', !m);
        });
      });
      if (!v) {
        if (addBtn) { addBtn.disabled = true; if (addLabel) addLabel.textContent = 'Unavailable'; }
        if (stock) stock.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (stickyPrice) stickyPrice.textContent = v.price;
      if (cmpEl) { cmpEl.textContent = v.compare || ''; cmpEl.hidden = !v.on_sale; }
      if (addBtn) { addBtn.disabled = !v.available; if (addLabel) addLabel.textContent = v.available ? 'Add to bag' : 'Sold out'; }
      if (stock) stock.textContent = v.available ? 'In stock' : 'Sold out';
      if (v.media) showSlide(v.media);
      try {
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
      } catch (e) {}
    }
    on(sec, 'click', function (e) {
      var b = e.target.closest('[data-option] button[data-value]');
      if (b) {
        $$('button[data-value]', b.closest('[data-option]')).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        update();
        return;
      }
      var t = e.target.closest('[data-media-target]');
      if (t) { showSlide(t.getAttribute('data-media-target')); return; }
      if (e.target.closest('[data-qty-minus]') || e.target.closest('[data-qty-plus]')) {
        var n = Number(qtyIn.value) + (e.target.closest('[data-qty-plus]') ? 1 : -1);
        if (n < 1) n = 1; if (n > 99) n = 99;
        qtyIn.value = n; qtyOut.textContent = n;
        return;
      }
      if (e.target.closest('[data-sticky-add]')) { if (form) form.requestSubmit ? form.requestSubmit() : form.submit(); }
    });
    on(form, 'submit', function (e) {
      if (!form || !window.fetch) return;
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      addBtn.disabled = true;
      addItems([{ id: Number(idInput.value), quantity: Number(qtyIn.value) || 1 }]).then(function (res) {
        addBtn.disabled = false;
        if (!res.ok) {
          if (errorEl) { errorEl.textContent = (res.data && (res.data.description || res.data.message)) || 'That could not be added.'; errorEl.hidden = false; }
          return;
        }
        afterAdd();
      }).catch(function () { addBtn.disabled = false; form.submit(); });
    });
    // sticky bar on phones
    var sticky = $('[data-sticky-buy]', sec);
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        sticky.hidden = visible || entries[0].boundingClientRect.top > 0;
      }).observe(addBtn);
    }
    update();
  }
  $$('[data-product-section]').forEach(initProduct);

  /* ---------- Recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || el.querySelector('.as-wall')) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var fresh = parseSection(html, '[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });

  /* ---------- Collection filters, sort and load more ---------- */
  var fdrawer = $('#filter-drawer');
  function applyFilters(form) {
    var section = $('[data-collection-section]');
    if (!section) return;
    var id = section.getAttribute('data-section-id');
    var fd = new FormData(form);
    var params = new URLSearchParams();
    fd.forEach(function (v, k) { if (String(v).trim() !== '') params.append(k, v); });
    var base = form.getAttribute('action') || location.pathname;
    var url = base + (params.toString() ? '?' + params.toString() : '');
    var openGroups = $$('details[open][data-filter-group]', form).map(function (d) { return d.getAttribute('data-filter-group'); });
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(id)).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = doc.createElement('div'); tmp.innerHTML = html;
      var swap = function (sel) { var a = $(sel), b = $(sel, tmp); if (a && b) a.innerHTML = b.innerHTML; else if (a && !b) a.innerHTML = ''; };
      swap('[data-results]');
      var fa = $('.as-facets'), nfa = $('.as-facets', tmp); if (fa && nfa) fa.innerHTML = nfa.innerHTML;
      var ap = $('[data-applied]'), nap = $('[data-applied]', tmp);
      if (ap && nap) { ap.innerHTML = nap.innerHTML; ap.hidden = nap.hidden; }
      var nf = $('[data-filters-form]', tmp);
      if (nf) {
        form.innerHTML = nf.innerHTML;
        $$('details[data-filter-group]', form).forEach(function (d) { d.open = openGroups.indexOf(d.getAttribute('data-filter-group')) > -1; });
      }
      history.pushState({}, '', url);
    }).catch(function () { location.href = url; });
  }
  on(doc, 'change', function (e) {
    var form = e.target.closest('[data-filters-form]');
    if (form) { applyFilters(form); return; }
    var sort = e.target.closest('[data-sort]');
    if (sort) { var f = $('[data-filters-form]'); if (f) applyFilters(f); else { var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); location.href = u.toString(); } }
  });
  on(doc, 'submit', function (e) {
    var form = e.target.closest('[data-filters-form]');
    if (form) { e.preventDefault(); applyFilters(form); closeLayer(fdrawer); }
  });
  on(doc, 'click', function (e) {
    var o = e.target.closest('[data-filters-open]');
    if (o && fdrawer) {
      var which = o.getAttribute('data-filters-open');
      openLayer(fdrawer);
      if (which) {
        var d = $('details[data-filter-group="' + which + '"]', fdrawer);
        if (d) { d.open = true; d.scrollIntoView({ block: 'nearest' }); }
      }
      return;
    }
    if (e.target.closest('[data-filters-close]') && fdrawer && !e.target.closest('[type=submit]')) { closeLayer(fdrawer); return; }
    var more = e.target.closest('[data-load-more]');
    if (more) {
      e.preventDefault();
      var section = $('[data-collection-section]');
      var id = section ? section.getAttribute('data-section-id') : '';
      var href = more.getAttribute('href');
      more.classList.add('is-busy');
      fetch(href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(id)).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = doc.createElement('div'); tmp.innerHTML = html;
        var grid = $('[data-grid]'), ngrid = $('[data-grid]', tmp);
        if (grid && ngrid) { while (ngrid.firstChild) grid.appendChild(ngrid.firstChild); }
        var m = $('[data-more]'), nm = $('[data-more]', tmp);
        if (m && nm) m.innerHTML = nm.innerHTML; else if (m) m.remove();
      }).catch(function () { location.href = href; });
    }
  });

  /* ---------- Hour of prayer ---------- */
  $$('[data-hour-section]').forEach(function (sec) {
    var h = new Date().getHours();
    var i = h >= 4 && h < 10 ? 0 : h >= 10 && h < 16 ? 1 : h >= 16 && h < 21 ? 2 : 3;
    var cols = $$('[data-hour-col]', sec);
    if (!cols[i]) i = 0;
    cols.forEach(function (c, j) { if (j === i) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current'); });
    var stops = [[150, 114.4], [450, 39.4], [750, 39.4], [1050, 114.4]];
    var sun = $('[data-hour-sun]', sec);
    if (sun && stops[i]) sun.setAttribute('transform', 'translate(' + stops[i][0] + ' ' + stops[i][1] + ')');
  });

  /* ---------- Article contents list ---------- */
  var art = $('[data-article-body]');
  var toc = $('[data-toc]');
  if (art && toc) {
    var heads = $$('h2', art);
    if (heads.length > 1) {
      var list = $('[data-toc-list]', toc);
      heads.forEach(function (h, i) {
        if (!h.id) h.id = 'section-' + (i + 1);
        var li = doc.createElement('li'), a = doc.createElement('a');
        a.href = '#' + h.id; a.textContent = h.textContent;
        li.appendChild(a); list.appendChild(li);
      });
      toc.hidden = false;
    }
  }

  /* ---------- Hearts (saved in this browser only) ---------- */
  var saved = [];
  try { saved = JSON.parse(store('as-wish') || '[]'); } catch (e) { saved = []; }
  function paintHearts() {
    $$('[data-wish]').forEach(function (b) { b.setAttribute('aria-pressed', saved.indexOf(b.getAttribute('data-wish')) > -1 ? 'true' : 'false'); });
  }
  on(doc, 'click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wish'), i = saved.indexOf(h);
    if (i > -1) saved.splice(i, 1); else saved.push(h);
    store('as-wish', JSON.stringify(saved));
    paintHearts();
  });
  paintHearts();

  /* ---------- Banner carousel ---------- */
  function initSlider(root) {
    var track = $('[data-slider-track]', root);
    if (!track || root.dataset.ready) return;
    root.dataset.ready = '1';
    var slides = $$('.as-car__slide', track);
    var dots = $$('[data-slider-dot]', root);
    var pauseBtn = $('[data-slider-pause]', root);
    var index = 0, timer = null, held = false, userPaused = false;
    var delay = Number(root.getAttribute('data-autoplay')) || 0;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    function pad() { return parseFloat(getComputedStyle(track).paddingLeft) || 0; }
    function slideLeft(s) { return s.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - pad(); }
    function go(i, smooth) {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slideLeft(slides[index]), behavior: smooth === false || reduce ? 'auto' : 'smooth' });
    }
    function paint() {
      var i = 0, best = Infinity;
      slides.forEach(function (s, j) {
        var d = Math.abs(slideLeft(s) - track.scrollLeft);
        if (d < best) { best = d; i = j; }
      });
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) i = slides.length - 1;
      index = i;
      dots.forEach(function (d, j) { if (j === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } track.setAttribute('aria-live', 'polite'); }
    function start() {
      if (delay > 0 && slides.length > 1 && !reduce && !timer && !held && !userPaused && !doc.hidden) {
        timer = setInterval(function () { go(index + 1); }, delay);
        track.setAttribute('aria-live', 'off');
      }
    }
    function hold() { held = true; stop(); }
    function release() { held = false; start(); }
    var raf = null;
    on(track, 'scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; paint(); }); }, { passive: true });
    on(root, 'click', function (e) {
      if (e.target.closest('[data-slider-pause]')) {
        userPaused = !userPaused;
        pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', userPaused ? 'Play the banners' : 'Pause the banners');
        if (userPaused) stop(); else start();
        return;
      }
      if (e.target.closest('[data-slider-prev]')) { go(index - 1); stop(); start(); return; }
      if (e.target.closest('[data-slider-next]')) { go(index + 1); stop(); start(); return; }
      var d = e.target.closest('[data-slider-dot]');
      if (d) { go(dots.indexOf(d)); stop(); start(); }
    });
    on(track, 'keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(index - 1); stop(); start(); }
      if (e.key === 'ArrowRight') { go(index + 1); stop(); start(); }
    });
    on(root, 'mouseenter', hold); on(root, 'mouseleave', release);
    on(root, 'focusin', hold); on(root, 'focusout', release);
    on(root, 'touchstart', hold, { passive: true });
    on(root, 'touchend', function () { setTimeout(release, 4000); }, { passive: true });
    on(root, 'touchcancel', release, { passive: true });
    on(window, 'resize', debounce(function () { go(index, false); }, 150));
    on(doc, 'visibilitychange', function () { if (doc.hidden) stop(); else start(); });
    start();
  }
  $$('[data-slider]').forEach(initSlider);

  /* ---------- Search bar on the page (Looking for, Occasion, Budget) ---------- */
  on(doc, 'submit', function (e) {
    var f = e.target.closest ? e.target.closest('[data-hs-form]') : null;
    if (!f) return;
    var q = $('[data-hs-q]', f), occ = $('[data-hs-occasion]', f), bud = $('[data-hs-budget]', f);
    var mn = $('[data-hs-min]', f), mx = $('[data-hs-max]', f);
    var words = q.value.trim();
    var o = occ ? occ.value : '';
    if (o && words.toLowerCase().indexOf(o.toLowerCase()) === -1) words = (words + ' ' + o).trim();
    q.value = words || '*';
    var parts = bud && bud.value ? bud.value.split('|') : [];
    mn.value = parts[0] || ''; mx.value = parts[1] || '';
    mn.disabled = !mn.value; mx.disabled = !mx.value;
  });

  /* Shopify theme editor: re-run product setup after a section reloads */
  on(doc, 'shopify:section:load', function (e) {
    $$('[data-product-section]', e.target).forEach(initProduct);
    $$('[data-slider]', e.target).forEach(initSlider);
    syncDusk();
  });
})();
